import { Component } from 'react'
import * as styles from 'styles/molecules/forms/Form.css'
import { Field, reduxForm } from 'redux-form'
import { FORM_CONTACT_EDIT, TELEPHONE_MASK } from 'constants/forms'
import { ReduxFormProps } from 'interfaces/component'
import schema from 'schemas/contactEditSchema'
import { getSaveButtonFormProps, shouldAsyncValidate } from 'helpers/formHelpers'
import { asyncValidator } from 'helpers/schemaHelpers'
import TextFieldWrapped from 'components/atoms/inputs/TextFieldWrapped'
import { ButtonStyle } from 'components/features/pfm/Button/Button'
import ButtonRow from 'components/atoms/buttons/ButtonRow'

export type ContactEditFormProps = ReduxFormProps & {
  onCancel: () => void
}

@reduxForm({
  form: FORM_CONTACT_EDIT,
  asyncValidate: asyncValidator(schema),
  shouldAsyncValidate,
})
class ContactEditForm extends Component<ContactEditFormProps, {}> {
  render () {
    const { handleSubmit, onCancel } = this.props

    return (
      <form className={ styles.form } onSubmit={ handleSubmit }>
        <ul>
          <li className={ styles.item }>
            <Field
              name='contact_email'
              props={{
                type: 'email',
                label: 'E-mail Address',
                autoFocus: true,
                qaMarker: 'email',
              }}
              component={ TextFieldWrapped }
            />
          </li>
          <li className={ styles.item }>
            <Field
              name='phone'
              component={ TextFieldWrapped }
              props={{
                placeholder: '(123)456-7890',
                label: 'Mobile Phone Number',
                type: 'tel',
                mask: TELEPHONE_MASK,
                qaMarker: 'phone-number',
              }}
            />
          </li>
          <li className={ styles.item }>
            <ButtonRow
              size='small'
              buttons={ [
                { text: 'Save', qaMarker: 'submit-button', submit: true, ...getSaveButtonFormProps(this.props) },
                { text: 'Cancel', qaMarker: 'cancel-button', style: 'hollow' as ButtonStyle, onClick: onCancel },
              ] }
            />
          </li>
        </ul>
      </form>
    )
  }
}

export default ContactEditForm
